import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=d46c61fa"
import script from "./Documents.ts?vue&type=script&lang=ts&external"
export * from "./Documents.ts?vue&type=script&lang=ts&external"
import style0 from "./Documents.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports